import { render, staticRenderFns } from "./buyNumber.vue?vue&type=template&id=e1caacb0"
import script from "./buyNumber.vue?vue&type=script&lang=js"
export * from "./buyNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports